var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCss(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#0277BD;}\r\n\t.st1{fill:#EBEBEB;}\r\n\t.st2{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(300, 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-288.8,0h25.5C-257,0-252,5-252,11.2v25.5c0,6.2-5,11.2-11.2,11.2h-25.5c-6.2,0-11.2-5-11.2-11.2V11.2 C-300,5-295,0-288.8,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-289.9,19.2l0.5,6h13.4v-6H-289.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-276,7.1L-276,7.1h-15l0.5,6h14.5V7.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-276,41v-6.2l0,0l-6.7-1.8l-0.4-4.8h-3.2h-2.8l0.8,9.4L-276,41L-276,41z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M-268.6,25.2l-0.7,7.8l-6.7,1.8V41l12.3-3.4l0.1-1l1.4-15.8l0.1-1.6l1.1-12.1h-15v6h8.4l-0.5,6.1h-7.9v6 H-268.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCss);
export default __webpack_public_path__ + "static/media/css.bf47c299915cf18cc5c15d69788919d5.svg";
export { ForwardRef as ReactComponent };